export * from './toasterMessages'

export const PASSWORD_MIN_LENGTH = 6;


// WEBPACK FOOTER //
// ./src/shared/constants/index.js